import { Button, Checkbox, FormControlLabel, Grid, makeStyles, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { AutoCompleteEfectorFacturacion } from './UI/AutoCompleteEfectorFacturacion';
import { useDispatch, useSelector } from 'react-redux';
import { cleanComprobantes, generarVoucherLiq, getComprobantesContadoresGestion, imprimirSolicitudPago } from '../../actions/liquidaciones/liquidaciones';
import { LIQUIDACIONES_COMPROBANTES_ESTADOS } from '../../utils/constants';
import { ComprobantesItems } from './gestionLiquidaciones/generacionVouchers/ComprobantesItems';
import { useForm } from '../../hooks/useForm';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from "moment";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";

const useStyles = makeStyles({
    root: {
        padding: 10,
        flexGrow: 1,
        marginTop: 10,
        // width: "100%",
    },
    input: {
        padding: 10,
    },
});

const stateInitial = {
    fechaDesde: moment().subtract(120, 'days'),
    fechaHasta: moment()
};


export const GeneracionVouchersHome = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [dense, setDense] = useState(true);
    const [page, setPage] = useState(0);
    const [selected, setSelected] = useState([]);
    const [idSolicitudPago, setIdSolicitudPago] = useState(0);

    const [
        formValues,
        ,
        ,
        setearValor,
        ,
        ,
        ,
        ,
        ,
    ] = useForm(stateInitial);
    const { fechaDesde, fechaHasta } = formValues;

    const {
        efectorSeleccionado,
        comprobantes: items,
    } = useSelector((state) => state.liquidaciones);

    useEffect(() => {
        dispatch(cleanComprobantes())
    }, [])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const idEstado = LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_SOLICITUD_PAGO

    const OPCION_IMPRESION = {
        IMPRIMIR_SOLICITUD: 1,
        IMPRIMIR_SOLICITUD_PAGO: 2,
        //IMPRIMIR_SOLICITUD_PAGO_DEBITOS_CRUZADOS: 3,
        ENVIAR_SOLICITUD_PAGO_DEBITOS_PRESTADOR: 4,
    };


    useEffect(() => {
        if (efectorSeleccionado?.idEfectorFacturacion) {
            dispatch(
                getComprobantesContadoresGestion(
                    efectorSeleccionado?.idEfectorFacturacion,
                    fechaDesde,
                    fechaHasta,
                    idEstado,
                    null
                )
            );
        }
    }, [
        dispatch,
        efectorSeleccionado?.idEfectorFacturacion,
        fechaDesde,
        fechaHasta
    ]);

    const handleClick = (event, item) => {
        const selectedIndex = selected.indexOf(item);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, item);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = items.map((n) => n);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const componentRef = React.useRef();

    const isSelected = (idComprobante) => selected.filter(s => s.idComprobante === idComprobante).length > 0;

    const handleGenerarComprobante = () => {
        let solicitudPagoActual;
        dispatch(generarVoucherLiq(selected.map(s => s.idComprobante), idEstado, setSelected, (idSolicitud) => {
            solicitudPagoActual = idSolicitud;
            setIdSolicitudPago(idSolicitud);
        }))
            .then(() => {
                dispatch(imprimirSolicitudPago(OPCION_IMPRESION.IMPRIMIR_SOLICITUD, solicitudPagoActual));
            })
            .catch((error) => {
                console.error("Error en el dispatch:", error);
            });
    };

    console.log("items", items)
    console.log("idSolicitudPago", idSolicitudPago)

    return (
        <Grid container className={classes.root} justify="center" spacing={1}>
            <Grid item xs={12}>
                <Grid container direction="row" alignItems="center" spacing={1}>
                    <Grid item xs={12} md={5}>
                        <Paper className={classes.input}>
                            <AutoCompleteEfectorFacturacion todos dontExecuteFetch />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Paper className={classes.input}>
                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    label="Fecha Desde"
                                    format="dd/MM/yyyy"
                                    required={true}
                                    clearLabel="Limpiar"
                                    cancelLabel="Cancelar"
                                    maxDate={fechaHasta}
                                    maxDateMessage={`La fecha no puede ser posterior a la fecha Hasta`}
                                    value={moment(fechaDesde).isValid()
                                        ? moment(fechaDesde)
                                        : null}
                                    onChange={(date) => {
                                        setearValor("fechaDesde", date);
                                    }}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Paper className={classes.input}>
                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    label="Fecha Hasta"
                                    format="dd/MM/yyyy"
                                    required={true}
                                    clearLabel="Limpiar"
                                    cancelLabel="Cancelar"
                                    minDate={fechaDesde}
                                    minDateMessage={`La fecha no puede ser anterior a la fecha de Desde`}
                                    value={moment(fechaHasta).isValid()
                                        ? moment(fechaHasta)
                                        : null}
                                    onChange={(date) => {
                                        setearValor("fechaHasta", date);
                                    }}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleGenerarComprobante}
                            style={{ marginTop: '16px' }}
                            disabled={selected.length === 0}
                        >
                            Generar Voucher
                        </Button>
                    </Grid>

                </Grid>
            </Grid>
            <Grid item xs={12}>
                <TableContainer component={Paper} style={{ overflowX: 'auto' }}>
                    <Table size={dense ? 'small' : 'medium'} ref={componentRef}>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">
                                    <Checkbox
                                        indeterminate={selected.length > 0 && selected.length < items.length}
                                        checked={items.length > 0 && selected.length === items.length}
                                        onChange={handleSelectAllClick}
                                        inputProps={{ "aria-label": "seleccionar todos los afiliados" }}
                                    />
                                </TableCell>
                                <TableCell align="left">Estado</TableCell>
                                <TableCell align="left">IdComprobante</TableCell>
                                <TableCell align="left">N° Factura</TableCell>
                                <TableCell align="left">Cliente</TableCell>
                                <TableCell align="left">CUIT</TableCell>
                                <TableCell align="left">P</TableCell>
                                <TableCell align="left">Total Comprobante</TableCell>
                                <TableCell align="left">Tipo Factura</TableCell>
                                <TableCell align="left">Fecha Recepción</TableCell>
                                <TableCell align="left">Fecha Vencimiento</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items.length > 0 && (
                                items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((item, index) => {
                                        const isItemSelected = isSelected(item.idComprobante);

                                        return (
                                            <ComprobantesItems
                                                item={item}
                                                key={item.idComprobante}
                                                handleClick={handleClick}
                                                isItemSelected={isItemSelected}
                                                estadoComprobantes={LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_SOLICITUD_PAGO}
                                                labelId={`enhanced-table-checkbox-${index}`}
                                            />
                                        );
                                    }))}
                            {items.length === 0 && (
                                <TableRow style={{ height: 50 }}>
                                    <TableCell
                                        colSpan={13}
                                        style={{ textAlign: "-webkit-center" }}
                                    >
                                        {" "}
                                        Sin Registros
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            {items.length > 0 && (
                <Grid item xs={12}>
                    <TablePagination
                        style={{ backgroundColor: 'white' }}
                        rowsPerPageOptions={[10, 20, 50]}
                        component="div"
                        count={items.length}
                        rowsPerPage={rowsPerPage}
                        labelRowsPerPage="Registros por página"
                        page={page}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={dense}
                                onChange={(e) => setDense(e.target.checked)}
                            />
                        }
                        label="Tamaño compacto"
                    />
                </Grid>
            )}
        </Grid>
    )
}
